var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4277,
    cy: 30.4277,
    r: 30.4277,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4708 29.1043V29.1044C52.4715 33.8987 50.9647 38.5653 48.1741 42.4167C45.3836 46.2679 41.4576 49.0998 36.9757 50.4974C32.494 51.895 27.6917 51.7851 23.2755 50.1839C19.0724 48.6599 15.429 45.861 12.8293 42.1673L52.4699 28.7301C52.4708 28.8505 52.4708 28.9746 52.4708 29.1043Z",
    fill: "#282D3A",
    stroke: "#282D3A",
    strokeWidth: 1.05838,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5392 18.9109C51.0842 21.6782 52.0053 24.7473 52.2411 27.9033L12.1482 41.207C10.4505 38.536 9.35414 35.525 8.93828 32.3831C8.49757 29.0535 8.83304 25.667 9.91845 22.4886C11.0039 19.3101 12.8098 16.4259 15.195 14.0613C17.5802 11.6967 20.4801 9.91586 23.6679 8.8581C26.8556 7.80034 30.2448 7.4943 33.5705 7.96391C36.8962 8.43351 40.0681 9.66603 42.8384 11.5651C45.6086 13.4642 47.902 15.9783 49.5392 18.9109Z",
    stroke: "#282D3A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDune);
export default __webpack_public_path__ + "static/media/dune.1de7212fba421317f70b1c481c43684e.svg";
export { ForwardRef as ReactComponent };